import { Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'st-travel-errors',
  templateUrl: './travel-errors.component.html',
  styleUrls: ['./travel-errors.component.scss']
})
export class TravelErrorsComponent {

  @Input() errors?: ValidationErrors | null = null;

}
